import { render } from "./LanguageModal.vue?vue&type=template&id=1fbc4ed6"
import script from "./LanguageModal.js?vue&type=script&lang=js"
export * from "./LanguageModal.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__